//use home(page of geoposition) (famaliving)
import {FamaUtils} from "../../classes/FamaUtils";

export class GeoInit {
    utils = FamaUtils.getInstance();
    confirmedCookieName = 'geo_confirmed_v2';

    constructor() {
        fama.utils.debug('GeoInit loaded')
        this.init();
        this.initForm();
        this.eventListeners();
    }

    init() {
        if(this.utils.checkCookie(this.confirmedCookieName)) {
            $(".geo-content").hide();
            this.persistCountry(decodeURIComponent(this.utils.getCookie('geo')), () => {});
        }else{
            $("body").addClass("stop-scroll");
        }
    }

    eventListeners() {
        $('.js-geoChange').on('click', () => {this.geoChangeForm()});
        $('.js-geoGo').on('click', (e) => {this.geoGo(e)});
    }

    initGeo(redirectUrl = null){
        $("body").addClass("stop-scroll");
        this.persistGeoSelection(() => {
            this.redirectOrSkip(redirectUrl || this.getSelectedLanguageUrl());
        });
    }

    skipGeo() {
        $(".geo-content").fadeOut();
        $("body").removeClass("stop-scroll");
    }

    geoChangeForm(){
        $('.wrap-init').addClass('d-none');
        $('.wrap-geo-form').removeClass('d-none');
    }

    geoGo(e){
        const $button = $(e.currentTarget);
        const redirectUrl = $button.data('redirect-url');
        const locale = $button.data('locale');
        const countryIso = $button.data('country-iso');

        this.setGeoCookies(countryIso, locale);
        this.persistCountry(countryIso, () => {
            this.redirectOrSkip(redirectUrl);
        });
    }

    initForm () {
        $(".wrap-geo-form").each((key, item) => {
            const id = $(item);
            const $countrySelect = id.find("select[name='pais']");
            const $languageSelect = id.find("select[name='lang']");

            $countrySelect.select2({
                dropdownParent: $('.geo-content')
            });

            $languageSelect.select2({
                dropdownParent: $('.geo-content'),
                minimumResultsForSearch: Infinity
            });

            $countrySelect.on("change", () => {
                const defaultLocale = this.getSelectedCountryDefaultLocale();

                if (defaultLocale && $languageSelect.find("option[value='" + defaultLocale + "']").length) {
                    $languageSelect.val(defaultLocale).trigger('change.select2');
                }

                this.setGeoCookies(this.getSelectedCountryIso(), this.getSelectedLanguage());
            });

            $languageSelect.on("change", () => {
                this.setGeoCookies(this.getSelectedCountryIso(), this.getSelectedLanguage());
            });

            $(".js-aceptChangeGeo").on("click", (e) => {
                e.preventDefault();
                this.initGeo();
            });
        });
    }

    persistGeoSelection(callback) {
        const countryIso = this.getSelectedCountryIso();
        const language = this.getSelectedLanguage();

        this.setGeoCookies(countryIso, language);
        this.persistCountry(countryIso, callback);
    }

    persistCountry(countryIso, callback) {
        if (!countryIso) {
            callback();
            return;
        }

        $.ajax({
            url: "/ajax.php?module=geoIP&action=setCountry&language=" + $('html').attr('lang'),
            data: {
                iso: countryIso
            },
            type: "post",
            dataType: "json",
            complete: () => {
                callback();
            }
        });
    }

    setGeoCookies(countryIso, language) {
        this.setCookie('geo', countryIso || '', 100);
        this.setCookie('language', language || $('html').attr('lang'), 100);
        this.setCookie(this.confirmedCookieName, '1', 100);
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        document.cookie = cname + "=" + encodeURIComponent(cvalue) + "; expires=" + d.toUTCString() + "; path=/";
    }

    getSelectedCountryIso() {
        return $('.geo-content').find("select[name='pais'] :selected").data('iso');
    }

    getSelectedCountryDefaultLocale() {
        return $('.geo-content').find("select[name='pais'] :selected").data('default-locale');
    }

    getSelectedLanguage() {
        return $('.geo-content').find("select[name='lang']").val();
    }

    getSelectedLanguageUrl() {
        return $('.geo-content').find("select[name='lang'] :selected").data('redirect-url');
    }

    redirectOrSkip(redirectUrl) {
        if (!redirectUrl) {
            this.skipGeo();
            return;
        }

        const targetUrl = new URL(redirectUrl, window.location.origin);
        const currentUrl = new URL(window.location.href);
        currentUrl.hash = '';
        targetUrl.hash = '';

        if (targetUrl.href !== currentUrl.href) {
            window.location.href = targetUrl.href;
            return;
        }

        this.skipGeo();
    }

}
